import axios from 'axios'
import axiosRetry, { isNetworkError } from 'axios-retry'

const isDev = import.meta.env.DEV

/**
 * Configured axios instance with retry logic via axios-retry.
 *
 * Retry policy:
 *  - 3 attempts with linear delay (1s, 2s, 3s)
 *  - Retries on network errors (no response) OR server errors (status >= 500) for GET requests only.
 *  - POST / PUT / PATCH are never retried on server errors.
 */
const http = axios.create()

axiosRetry(http, {
  retries: 3,

  retryDelay: (retryCount) => retryCount * 1000, // 1000ms, 2000ms, 3000ms

  retryCondition: (error) => {
    // Always retry on network errors (no response at all)
    if (isNetworkError(error)) {
      return true
    }

    // For server errors (5xx) only retry safe, idempotent GET requests
    if (error.response && error.response.status >= 500) {
      const method = error.config?.method?.toLowerCase()
      return method === 'get'
    }

    return false
  },

  onRetry: (retryCount, error) => {
    if (isDev) {
      console.warn(
        `[axios-retry] Attempt #${retryCount} for ${error.config?.url ?? 'unknown URL'}`,
        `— status: ${error.response?.status ?? 'network error'}`
      )
    }
  }
})

export default http
